<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Sổ điểm" :link="[{ text: 'Sổ điểm', href: '../student-mark' }]" />
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <StudentMarkFilter :defaultStudentId="defaultStudentId" @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card v-show="student && student.id" class="mx-4 elevation-0" outlined>
      <v-row class="ma-6 justify-end">
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
      </v-row>

      <StudentMarkDataTable class="px-6 pb-6" ref="table" />
    </v-card>
    <MarkBlankView v-if="!student || !student.id" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState } from 'vuex'
import StudentMarkFilter from '@/modules/student/mark/StudentMarkFilter.vue'
import StudentMarkDataTable from '@/modules/student/mark/StudentMarkDataTable.vue'
import MarkBlankView from '@/modules/mark/MarkBlankView.vue'

export default {
  components: {
    Breadcrumbs,
    StudentMarkFilter,
    StudentMarkDataTable,
    MarkBlankView
  },
  data() {
    return {
      factors: [],
      avgMarkYear: [],
      semesterData: {},
      defaultStudentId: ''
    }
  },
  computed: {
    ...mapState('subjects', ['subjects', 'defaultFactors']),
    ...mapState('StudentMark', ['student'])
  },
  mounted() {
    let param = {}
    if (this.$route.query.student) {
      param.student = this.$route.query.student
      this.defaultStudentId = this.$route.query.student
    }
  },
  methods: {
    ...mapActions('StudentMark', ['fetchMarks', 'setSubjects', 'setSemester', 'setFactors']),
    ...mapActions('subjects', ['fetchSubjects']),

    onFilterChanged(query) {
      this.$refs.table.refresh(query)
    },

    exportExcel() {
      // todo
    }
  }
}
</script>

<style></style>
